// token.interceptor.ts

import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const accessToken = localStorage.getItem('currentUser');
        console.log('accessToken', JSON.parse(accessToken!));
        
        if (accessToken) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${JSON.parse(accessToken!).data.accessToken}`
                }
            });
        }

        return next.handle(request);
    }
}
